import contactusRequestSentLogo from "../assets/images/contact-us-request-sent.png";
import usaFlag from "../assets/images/usa-flag.svg";
import prophylacticVaccinesIcon from "../assets/images/prophylactic-vaccines-icon.png";
import privacyPolicyDataTable from "../assets/images/privacy-policy-data-table.png";
import privacyPolicyDataTable_EU from "../assets/images/privacy-policy-data-table-EU.png";
import Banner_Strand from "../assets/images/Banner_Strand.png"

export const contactUsPageData = {
    "items": [
      {
        "fields": {
          "name": "Contact Us - Contact Us Page Template",
          "modules": [
            {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "2y5JNbGCdLulrhbyD0VSZ5",
                "type": "Entry",
                "createdAt": "2022-12-02T04:34:18.506Z",
                "updatedAt": "2023-09-22T16:32:41.034Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 39,
                "revision": 6,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "bannerComponent"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Contact Us Banner Component",
                "headline": "Contact Us",
                "backgroundImage": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "5zfGJA7or5WGcLdYi4Qde",
                    "type": "Asset",
                    "createdAt": "2022-10-28T18:53:29.208Z",
                    "updatedAt": "2022-10-28T18:53:29.208Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 6,
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Banner BG Strand Top",
                    "description": "",
                    "file": {
                      "url": Banner_Strand,
                      "details": {
                        "size": 47693,
                        "image": {
                          "width": 1920,
                          "height": 511
                        }
                      },
                      "fileName": "Banner BG Strand Top .png",
                      "contentType": "image/png"
                    }
                  }
                },
                "message": "Ready to order or have questions? We're here to help. Contact us for any guidance or information you need. Your satisfaction is our priority and we eagerly await the opportunity to serve you.",
                "country": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "7sht7920U6vs3CLH2CUyaa",
                    "type": "Entry",
                    "createdAt": "2023-05-18T03:23:50.744Z",
                    "updatedAt": "2023-05-24T22:55:23.250Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 6,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "country"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "name": "United States",
                    "isocode": "US",
                    "flag": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "3aYCbZJiL8aoEKRdhjOXyy",
                        "type": "Asset",
                        "createdAt": "2023-05-24T22:54:50.939Z",
                        "updatedAt": "2023-05-24T22:54:50.939Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 5,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "usa flag",
                        "description": "USA Flag",
                        "file": {
                          "url": usaFlag,
                          "details": {
                            "size": 2487,
                            "image": {
                              "width": 36,
                              "height": 26
                            }
                          },
                          "fileName": "usa_flag.svg",
                          "contentType": "image/svg+xml"
                        }
                      }
                    },
                    "locales": [
                      "en-US"
                    ]
                  }
                }
              }
            },
            {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "bZN3ozoAd7NgLj1g3GLIQ",
                "type": "Entry",
                "createdAt": "2022-12-02T04:25:12.254Z",
                "updatedAt": "2024-05-28T21:10:01.634Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 45,
                "revision": 14,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "contactUsCardComponent"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Care Team Contact Us Card - US",
                "headline": "To place an order or for support",
                "message": {
                  "nodeType": "document",
                  "data": {},
                  "content": [
                    {
                      "nodeType": "paragraph",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "1-866-MODERNA (1-866-663-3762)",
                          "marks": [],
                          "data": {}
                        }
                      ]
                    },
                    {
                      "nodeType": "paragraph",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "8:00AM - 8:00PM, Monday - Friday",
                          "marks": [],
                          "data": {}
                        }
                      ]
                    },
                    {
                      "nodeType": "paragraph",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "WeCare@modernatx.com",
                          "marks": [],
                          "data": {}
                        }
                      ]
                    },
                    {
                      "nodeType": "paragraph",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "\n",
                          "marks": [],
                          "data": {}
                        }
                      ]
                    }
                  ]
                },
                "icon": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "2wQ7GSaGNr9QsirrrDwWrJ",
                    "type": "Asset",
                    "createdAt": "2022-10-28T13:45:09.591Z",
                    "updatedAt": "2022-12-09T19:13:58.864Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 11,
                    "revision": 2,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Faq Category Icon",
                    "description": "Faq Category SVG",
                    "file": {
                      "url": prophylacticVaccinesIcon,
                      "details": {
                        "size": 40893,
                        "image": {
                          "width": 600,
                          "height": 600
                        }
                      },
                      "fileName": "Moderna_Icon_ProphylacticVaccines.png",
                      "contentType": "image/png"
                    }
                  }
                },
                "country": "[Circular Reference]"
              }
            },
            {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "7wREbh7uFf1amAX5Occ9dj",
                "type": "Entry",
                "createdAt": "2022-12-02T04:28:54.232Z",
                "updatedAt": "2024-12-13T22:26:19.433Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 31,
                "revision": 10,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "contactUsCardComponent"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Report Adverse Event Contact Us Card - US",
                "headline": "Report an adverse event",
                "message": {
                  "data": {},
                  "content": [
                    {
                      "data": {},
                      "content": [
                        {
                          "data": {},
                          "marks": [],
                          "value": "Click the arrow to submit an adverse event report",
                          "nodeType": "text"
                        },
                        {
                          "data": {},
                          "marks": [],
                          "value": "\n",
                          "nodeType": "text"
                        }
                      ],
                      "nodeType": "paragraph"
                    }
                  ],
                  "nodeType": "document"
                },
                "icon": "[Circular Reference]",
                "link": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "6mzHEzPj12cIX1TCNBE7p2",
                    "type": "Entry",
                    "createdAt": "2021-12-15T18:53:22.036Z",
                    "updatedAt": "2023-01-10T22:05:28.098Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 7,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "externalLink"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Get Help - Moderna Expert Link",
                    "label": "Get Help - Moderna Expert ",
                    "url": "https://report.moderna.convergehealthsafety.com/"
                  }
                },
                "country": "[Circular Reference]",
                "label": "Report an adverse event"
              }
            },
            {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "46fjepI7RrVzgj8ua6WqFv",
                "type": "Entry",
                "createdAt": "2022-12-02T04:29:45.465Z",
                "updatedAt": "2024-12-13T22:25:31.150Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 14,
                "revision": 4,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "contactUsCardComponent"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "FAQ Contact Us Card - US",
                "headline": "FAQs",
                "message": {
                  "data": {},
                  "content": [
                    {
                      "data": {},
                      "content": [
                        {
                          "data": {},
                          "marks": [],
                          "value": "Frequently asked questions about Moderna Direct\n\n",
                          "nodeType": "text"
                        }
                      ],
                      "nodeType": "paragraph"
                    }
                  ],
                  "nodeType": "document"
                },
                "icon": "[Circular Reference]",
                "link": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "4sGXFZd1qHOz98lelP3ptv",
                    "type": "Entry",
                    "createdAt": "2022-10-25T05:36:49.166Z",
                    "updatedAt": "2023-09-11T17:49:57.795Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 11,
                    "revision": 3,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "internalLink"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "FAQs Link",
                    "label": "Frequently Asked Questions ",
                    "pageReference": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "16VVyRwgvsqxp7Q0GBqDwl",
                        "type": "Entry",
                        "createdAt": "2022-10-26T23:39:27.943Z",
                        "updatedAt": "2022-10-26T23:39:27.943Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 11,
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "page"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "Main FAQ Page",
                        "title": "Page Title from Compose",
                        "slug": "faqs",
                        "seo": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3mfYDCFlr6nPLagdXV7jo8",
                            "type": "Entry",
                            "createdAt": "2022-10-26T23:39:28.038Z",
                            "updatedAt": "2022-10-26T23:39:28.038Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 26,
                            "revision": 1,
                            "contentType": {
                              "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                              }
                            },
                            "locale": "en-US"
                          },
                          "fields": {
                            "name": "Main FAQ Page - Compose: SEO",
                            "title": "Frequently Asked Questions Moderna",
                            "description": "This page provides answers to frequently asked questions on Moderna Direct",
                            "no_index": false,
                            "no_follow": false
                          }
                        },
                        "content": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "1c7FRISzjyCWuduGT6H36O",
                            "type": "Entry",
                            "createdAt": "2022-10-26T23:39:28.060Z",
                            "updatedAt": "2022-10-28T13:50:25.044Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 6,
                            "revision": 2,
                            "contentType": {
                              "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "pageFaqsPageTemplate"
                              }
                            },
                            "locale": "en-US"
                          },
                          "fields": {
                            "name": "Main FAQ Page - FAQs Page Template",
                            "faqModules": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "55Xgsw7Lb26fvzm4vznbe3",
                                "type": "Entry",
                                "createdAt": "2022-10-26T23:39:28.125Z",
                                "updatedAt": "2023-05-30T19:07:13.038Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 24,
                                "revision": 7,
                                "contentType": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "ContentType",
                                    "id": "faqPage"
                                  }
                                },
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "FAQs Page",
                                "banner": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Entry",
                                    "id": "7FSPIxBv2f8DUuOYNyjN2f"
                                  }
                                },
                                "contactUsCtaComponent": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Entry",
                                    "id": "6gqCKf6EtK3mI0yNzKHx5h"
                                  }
                                }
                              }
                            },
                            "faqCategoryIcon": "[Circular Reference]"
                          }
                        }
                      }
                    }
                  }
                },
                "country": "[Circular Reference]",
                "label": "View Frequently Asked Questions"
              }
            },
            {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "1UNli48LSxpoJIrKw23H1N",
                "type": "Entry",
                "createdAt": "2022-12-02T04:19:00.121Z",
                "updatedAt": "2023-09-28T16:53:26.696Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 28,
                "revision": 5,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "contactUsFormComponent"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Contact Us Form Component",
                "headline": "Ask a Question or Request to be Contacted",
                "message": {
                  "nodeType": "document",
                  "data": {},
                  "content": [
                    {
                      "nodeType": "paragraph",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "Enter your contact details and select how we can help you.",
                          "marks": [],
                          "data": {}
                        }
                      ]
                    }
                  ]
                },
                "fullNameLabel": "Full Name",
                "fullNamePlaceholder": "Enter full name",
                "emailLabel": "Email",
                "emailPlaceholder": "Enter email",
                "phoneLabel": "Phone",
                "phonePlaceholder": "Enter phone",
                "organizationLabel": "Organization",
                "organizationPlaceholder": "Enter organization",
                "preferredMethodLabel": "Preferred method of contact",
                "preferredMethodList": [
                  "Email",
                  "Phone"
                ],
                "supportCategoryLabel": "What can we help you with?",
                "supportCategoryList": [
                  "Contract and Billing",
                  "Order Assistance",
                  "Product Inquiry",
                  "Account Information",
                  "General Inquiry",
                  "Other"
                ],
                "consentMessageLabel": "I consent to the Moderna",
                "consentLink": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "556dZCOMwLIKu69guk6x42",
                    "type": "Entry",
                    "createdAt": "2022-12-02T04:18:56.045Z",
                    "updatedAt": "2022-12-02T04:18:56.045Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 6,
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "internalLink"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Privacy Policy Internal Link",
                    "label": "Privacy Policy",
                    "pageReference": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "EW4a3Hd56gtuvG9WpsS3Z",
                        "type": "Entry",
                        "createdAt": "2022-12-02T04:18:46.677Z",
                        "updatedAt": "2022-12-02T04:18:46.677Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 10,
                        "revision": 1,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "page"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "Privacy Policy",
                        "title": "Moderna Direct Privacy Policy",
                        "slug": "privacy-policy",
                        "seo": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "5wVt4P86v56AQIbQiW4uqD",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:18:46.768Z",
                            "updatedAt": "2022-12-02T04:18:46.768Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 4,
                            "revision": 1,
                            "contentType": {
                              "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                              }
                            },
                            "locale": "en-US"
                          },
                          "fields": {
                            "name": "Privacy Policy - Compose: SEO"
                          }
                        },
                        "content": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3LQ4u17dvJworzbcVeWMD",
                            "type": "Entry",
                            "createdAt": "2022-12-02T04:18:46.882Z",
                            "updatedAt": "2023-06-20T16:20:31.348Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 14,
                            "revision": 4,
                            "contentType": {
                              "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "richTextContentPageTemplate"
                              }
                            },
                            "locale": "en-US"
                          },
                          "fields": {
                            "name": "Privacy Policy - Rich Text Content Page Template",
                            "modules": [
                              {
                                "metadata": {
                                  "tags": [],
                                  "concepts": []
                                },
                                "sys": {
                                  "space": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "Space",
                                      "id": "n9bebhw263o0"
                                    }
                                  },
                                  "id": "4qpojknXqxo8gNLhMxZz5K",
                                  "type": "Entry",
                                  "createdAt": "2022-12-11T23:10:53.907Z",
                                  "updatedAt": "2023-06-16T18:23:32.364Z",
                                  "environment": {
                                    "sys": {
                                      "id": "sandbox",
                                      "type": "Link",
                                      "linkType": "Environment"
                                    }
                                  },
                                  "publishedVersion": 7,
                                  "revision": 2,
                                  "contentType": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "ContentType",
                                      "id": "bannerComponent"
                                    }
                                  },
                                  "locale": "en-US"
                                },
                                "fields": {
                                  "title": "Privacy Statement Banner Component",
                                  "headline": "Moderna's Privacy Statement",
                                  "backgroundImage": "[Circular Reference]",
                                  "country": "[Circular Reference]"
                                }
                              },
                              {
                                "metadata": {
                                  "tags": [],
                                  "concepts": []
                                },
                                "sys": {
                                  "space": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "Space",
                                      "id": "n9bebhw263o0"
                                    }
                                  },
                                  "id": "3OFyHSrhG9cqdAH1JtdQcK",
                                  "type": "Entry",
                                  "createdAt": "2023-06-16T18:25:11.324Z",
                                  "updatedAt": "2023-06-16T18:25:11.324Z",
                                  "environment": {
                                    "sys": {
                                      "id": "sandbox",
                                      "type": "Link",
                                      "linkType": "Environment"
                                    }
                                  },
                                  "publishedVersion": 3,
                                  "revision": 1,
                                  "contentType": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "ContentType",
                                      "id": "bannerComponent"
                                    }
                                  },
                                  "locale": "en-US"
                                },
                                "fields": {
                                  "title": "Privacy Statement Banner Component - DE",
                                  "headline": "Moderna's Privacy Statement",
                                  "backgroundImage": "[Circular Reference]",
                                  "country": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "Entry",
                                      "id": "7DX7badGk41XRSy4znPNFI"
                                    }
                                  }
                                }
                              },
                              {
                                "metadata": {
                                  "tags": [],
                                  "concepts": []
                                },
                                "sys": {
                                  "space": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "Space",
                                      "id": "n9bebhw263o0"
                                    }
                                  },
                                  "id": "I5IZLNooED1CgxC5Kpr9Z",
                                  "type": "Entry",
                                  "createdAt": "2022-12-11T01:44:45.550Z",
                                  "updatedAt": "2024-07-10T14:10:03.932Z",
                                  "environment": {
                                    "sys": {
                                      "id": "sandbox",
                                      "type": "Link",
                                      "linkType": "Environment"
                                    }
                                  },
                                  "publishedVersion": 386,
                                  "revision": 22,
                                  "contentType": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "ContentType",
                                      "id": "richTextContentComponent"
                                    }
                                  },
                                  "locale": "en-US"
                                },
                                "fields": {
                                  "title": "Privacy Policy Rich Text Content Component - US",
                                  "effectiveDateLabel": "Effective",
                                  "effectiveDate": "2023-09-01",
                                  "content": {
                                    "nodeType": "document",
                                    "data": {},
                                    "content": [
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "This Privacy Statement describes how Moderna Inc. and its worldwide affiliates (“Moderna”, “we”, “our” or “us”) describes how Moderna collects, stores, uses (“processes) your personal data when you:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "use our website ",
                                                    "marks": [],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "hyperlink",
                                                    "data": {
                                                      "uri": "https://www.modernatx.com/"
                                                    },
                                                    "content": [
                                                      {
                                                        "nodeType": "text",
                                                        "value": "www.modernatx.com",
                                                        "marks": [],
                                                        "data": {}
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": " or any other Moderna website that links to this statement;",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "use any of our other digital services, such as an app provided by Moderna, that link or use this statement; or",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "engage with us through our call centers.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "“",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "Personal Data” ",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "means information associated with or used to directly or indirectly identify or contact a specific person. Such data can include your name, contact details, relationship with Moderna, etc.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Certain Personal Data, such as information about health or medical status (pursuant to all applicable laws) are characterized as sensitive (collectively, “",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "Sensitive Personal Data",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "”) and may be subject to stricter regulation and consent requirements than other information.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna recognizes the importance of taking steps to protect the privacy of information we collect, and we are committed to respecting your privacy.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Carefully read this Privacy Statement to learn more about how we collect, use, disclose and store personal data provided and the steps we take to help protect the often-sensitive personal data provided from unauthorized use or disclosure. When you submit information to or through our sites or services, you consent to the collection, processing and retention of your information as described in this Privacy Statement.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "IF YOU DO NOT AGREE WITH ANY PART OF THIS PRIVACY STATEMENT, THEN PLEASE DO NOT USE ANY OF THESE SERVICES.",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Summary of Key Points",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "This summary provides key points from our Privacy Statement, but you can find more information about any of these topics by using the Table of Contents below. ",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "1. How do we process your personal data?",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We process your personal data to provide you with the service requested and to improve our service, communicate with you for security purposes and comply with legal obligations. We only process your personal data when we have legal grounds to do so. Please see ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-4-how-we-use-personal-data"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "How We Use Your Personal Data",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " for more details.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "2. Do we process sensitive personal data?",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may process sensitive personal data when necessary, with your consent or where required by legal obligations. Click ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-1"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "here",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " to learn more about Sensitive Personal Data.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "3. Where will your data be processed by Moderna?",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna is a global company which maintains datacenters around the world, including Switzerland and the United States (ModernaTX’s global headquarters). Moderna may process personal data in databases that can be accessed by authorized Moderna personnel worldwide.Transfers of personal data among Moderna and its worldwide affiliates follow applicable laws and our Intracompany Transfer Agreements.Third-party transfers outside of the EU, the EEA, Switzerland or the UK are made in accordance with applicable privacy laws and pursuant to the following safeguard, Standard Contractual Clauses (SCCs) or Model Contracts.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "For information on SCCs, please visit:",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              },
                                              {
                                                "nodeType": "unordered-list",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "list-item",
                                                    "data": {},
                                                    "content": [
                                                      {
                                                        "nodeType": "paragraph",
                                                        "data": {},
                                                        "content": [
                                                          {
                                                            "nodeType": "text",
                                                            "value": "If in EU:",
                                                            "marks": [],
                                                            "data": {}
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "nodeType": "paragraph",
                                                        "data": {},
                                                        "content": [
                                                          {
                                                            "nodeType": "text",
                                                            "value": "",
                                                            "marks": [],
                                                            "data": {}
                                                          },
                                                          {
                                                            "nodeType": "hyperlink",
                                                            "data": {
                                                              "uri": "http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm"
                                                            },
                                                            "content": [
                                                              {
                                                                "nodeType": "text",
                                                                "value": "http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm",
                                                                "marks": [],
                                                                "data": {}
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "nodeType": "text",
                                                            "value": "",
                                                            "marks": [],
                                                            "data": {}
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "nodeType": "list-item",
                                                    "data": {},
                                                    "content": [
                                                      {
                                                        "nodeType": "paragraph",
                                                        "data": {},
                                                        "content": [
                                                          {
                                                            "nodeType": "text",
                                                            "value": "If in Switzerland:",
                                                            "marks": [],
                                                            "data": {}
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "nodeType": "paragraph",
                                                        "data": {},
                                                        "content": [
                                                          {
                                                            "nodeType": "text",
                                                            "value": "",
                                                            "marks": [],
                                                            "data": {}
                                                          },
                                                          {
                                                            "nodeType": "hyperlink",
                                                            "data": {
                                                              "uri": "https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647"
                                                            },
                                                            "content": [
                                                              {
                                                                "nodeType": "text",
                                                                "value": "https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647",
                                                                "marks": [],
                                                                "data": {}
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "nodeType": "text",
                                                            "value": "",
                                                            "marks": [],
                                                            "data": {}
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "nodeType": "list-item",
                                                    "data": {},
                                                    "content": [
                                                      {
                                                        "nodeType": "paragraph",
                                                        "data": {},
                                                        "content": [
                                                          {
                                                            "nodeType": "text",
                                                            "value": "If In UK:",
                                                            "marks": [],
                                                            "data": {}
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "nodeType": "paragraph",
                                                        "data": {},
                                                        "content": [
                                                          {
                                                            "nodeType": "text",
                                                            "value": "",
                                                            "marks": [],
                                                            "data": {}
                                                          },
                                                          {
                                                            "nodeType": "hyperlink",
                                                            "data": {
                                                              "uri": "https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit"
                                                            },
                                                            "content": [
                                                              {
                                                                "nodeType": "text",
                                                                "value": "https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit",
                                                                "marks": [],
                                                                "data": {}
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "nodeType": "text",
                                                            "value": "",
                                                            "marks": [],
                                                            "data": {}
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "4. When and with who do we share your data?",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We only will share your data with services providers who support our operations and other parties and business partners in limited circumstances based on legal obligations and as identified in our Privacy Notices.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "5. How do we keep your data protected?",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We have technical and organizational safeguards in place to protect your personal data. However, no electronic processing can be guaranteed to be 100% secure, so we cannot promise that hackers, cybercriminals or other unauthorized third parties will not be able to defeat our security and steal or unauthorized access your personal data. Click ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-6-how-information-is-retained-and-secured"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "here",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " to learn more.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "6. What are your rights and how can you exercise them?",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Based on your location, applicable personal data protection laws provide you with certain rights regarding your personal data. You may exercise these rights by visiting our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [
                                                  {
                                                    "type": "bold"
                                                  }
                                                ],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Please note that this Privacy Statement does not apply to information collected through third-party websites or services that you may access through third-party sites.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Data Controller:",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " The controller of Personal Data collected under this Privacy Statement is ModernaTX, Inc.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "This statement is organized into the following sections – please select your desired topic for further information.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Principles",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We will handle your Personal Data in accordance with applicable laws such as the General Data Protection Regulation (“GDPR”) in the European Union, the Act on the Protection of Personal data of Japan and the Personal data Act of South Korea. It is our goal to do the following:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Process Personal Data lawfully, fairly and in a transparent manner.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Collect Personal Data for a specified, explicit and legitimate purpose, and only use it for the purposes for which it was originally collected.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Limit collection of Personal Data to the extent necessary in relation to the purpose for which it is processed.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Make reasonable efforts to ensure that your Personal Data is accurate and, where necessary, kept up to date.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Store Personal Data for no longer than is necessary for the purpose for which the Personal Data is processed.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Process Personal Data in a manner that provides adequate security and confidentiality.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Our privacy practices are described in greater detail in the remainder of this Privacy Statement.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Table of Contents",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "1. Information We Collect\n2. How Information is Collected and Used\n3. Links to Other Websites/Services\n",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "4. ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "How We Use Personal Data\n5. How Information is Shared and Disclosed\n6. How Information is Retained and Secured\n7. Cookies and Similar Technologies\n8. Your Privacy Rights\n9. Our Children’s Policy\n10. Changes to This Privacy Statement\n11. Jurisdiction-Specific Privacy Information (",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "California, Nevada, EU/EEA, UK & Switzerland, Japan)",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "1. Information We Collect",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Depending on your interactions with us, we may collect and process your Personal Data. For example, you may choose to submit your contact information to join our mailing list, engage with us via our Contact Us features, or apply for a job opening with Moderna via the ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/careers/life-at-moderna"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "careers",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " section of our website. As a result, and depending on the type of Service, we may ask you to provide Personal Data, such as your:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "General identification data",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ": initials, name, job title, company name, country, date of birth, age, country, ethnicity (",
                                                    "marks": [],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "for cases where the Summary of Product Characteristics (SmPC) includes specific information relating to the ethnic origin",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ")",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Contact details",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ": contact number, e-mail address, mailing address",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Product use",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ": data related to your use of our products, including feedback and use history",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Professional details (for HCPs)",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ": job title, institute/organization name, additional information about your job role and any other job-related information",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Technical data",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ": IP address, device identifiers, operating system, browsing history, search history, time and duration of use, interaction with content",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Information about your job role",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": " and any other job-related information, work experience, educational background",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Before providing it to us, carefully consider whether to disclose your Sensitive Personal Data. If you do provide Sensitive Personal Data to us, you consent to its use and disclosure for the purposes and in the manner described in this Privacy Statement.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You may visit our website without voluntarily providing any information about yourself. You are not obligated to provide any Personal Data to us, but your ability to use our website or its features, apply for an employment position or report an adverse event may be limited. When calling our call centers, you can choose to remain anonymous unless the collection of personal data is required by law or you provide us with your personal data.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you provide us with Personal Data about another person or allow us to collect it, you acknowledge that you have the authority to share that information and are allowing us to use the information as described in this Privacy Statement.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Ordering and Payment Information for Pharmacies and Healthcare Professionals",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When pharmacies and healthcare professionals place orders for our products and services, we collect and use necessary information to process these transactions. This includes, but is not limited to, payment details (such as credit card numbers and billing addresses), order information, and contact details of the ordering party. This information is used solely for the purposes of fulfilling orders, processing payments, and providing customer support. We are committed to protecting this data in compliance with all relevant privacy and data protection regulations and ensuring that it is handled securely and confidentially.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "2. How Information is Collected and Used",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "a. Information that you voluntarily provide",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We collect and use the Personal Data that you voluntarily provide to us by visiting our sites or using our services. You may use certain services without registering or identifying yourself but, if you do not register, you may not have access to all of the services or functionality of the site. If you choose to register, we may use the Personal Data you provide to confirm your registration and to respond to requests from you.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Upon your request, we may also use your Personal Data to send you special promotions or newsletters with information that may interest you.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you are a healthcare professional or an institutional healthcare provider, you are responsible for obtaining any legally required authorization, consent or other permission from your patients prior to providing their Personal Data to Moderna. By submitting any Personal Data about a patient, you represent and warrant to Moderna that you have obtained all required permissions to do so.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "b. Through your use of interactive services",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you choose to participate in our questionnaires and surveys and other interactive services, we will collect the information, including health-related information and other Sensitive Personal Data that you share to help us better understand how Moderna products are used in coping with the diseases for which they are marketed.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "c. When you’re interested in enrolling in a clinical trial",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you submit health-related Personal Data to us to participate in a clinical trial, we may use your Personal Data to assess whether you qualify for enrollment in the trial, to contact you about potential participation in the trial, and to provide you with additional information about the trial.Once enrolled for any questions relating to your participation in a clinical trial, contact the Principal Investigator on the study and/or refer to the trail related information provided to you, e.g., the Informed Consent Form.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "d. When you correspond with Moderna about Moderna products.",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you contact Moderna or use the Services to ask questions or report problems regarding your experience in using one of our products, we may use the information you provide in submitting reports to the U.S. Food and Drug Administration, the European Medicines Agency or any other relevant supervisory authority and as otherwise required of us by law. We also may use the information to contact the prescribing physician to follow up regarding an event involving use of our product.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "e. Through data collection tools",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When permitted or you have provided consent, Moderna automatically will collect information about use of the Services through data collection tools, such as web beacons and cookies. A \"web beacon\" is a piece of code that enables us to monitor user activity and website traffic. A \"cookie\" is a randomly generated unique numeric code stored in the user’s web browser settings or computer’s hard drive. A cookie typically contains the name of the domain (internet location) from which the cookie originated, the “lifetime” of the cookie (i.e., when it expires), as well as the randomly generated unique numeric code.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "For more details, please see ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/cookie-statement"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "Moderna’s Cookie Statement",
                                                "marks": [
                                                  {
                                                    "type": "italic"
                                                  }
                                                ],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We use the information collected through data collection tools to monitor usage patterns, store information about user preferences and to improve the Services. For example, your Personal Data may be used to create customized offers, information and services tailored to your interests and preferences. We may track your activities over time and across third-party websites, apps or other online services to display advertisements on third-party websites. If you do not want us to use your information in this way, please see “Your Privacy Choices” below.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We also may collect information about the location of the mobile device or tablet used to access the Services (“Location Data”). Location Data includes: (i) the location of the mobile device or tablet derived from GPS or WiFi use; (ii) the IP address of the mobile device or tablet or internet service used to access the Services; and (iii) other information made available by a user or others that indicates the current or prior location of the user, such as geotag information in photographs.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "f. Social media connections",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When accessing the Services through a Facebook or other Social Media account, Moderna may (depending on applicable user privacy settings) automatically have access to information provided to or through the Social Media platform. Moderna may collect and use this information for the purposes described in this Privacy Statement or at the time the information was collected.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "g. Social media plugins",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When you use services, Social Media operators can place a cookie on your computer to recognize individuals who have visited previously. If you are logged into a Social Media account while using the services, the social plugins allow that Social Media to receive information that you have accessed and used the Services. The social plugins also allow the Social Media operator to share information about your activities in or through the Services with other Social Media users. Moderna does not control any of the content from the Social Media plugins. For more information about Social Media plugins, please refer to any privacy and/or other legal notices of the respective Social Media platform.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "h. Through third parties",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Third parties that assist us with our business operations also collect and use information (including Personal Data and Usage Data) and may share the collected information with us. For example, our vendors collect and share information with us to improve user experience, we may view your LinkedIn profile, or any other publicly available profile.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When you access any interactive service, you will be asked to affirmatively choose (\"opt in\") to provide the requested information. You may always choose not to provide the requested information but then you may not be able to use the Service as intended.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "3. Links to Other Websites/Services",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "As a convenience to our visitors, this website may contain links to other websites that we believe may offer useful information, but that does not mean that Moderna endorses it, or the quality or accuracy of information presented on it. If you decide to visit a third-party site, you are subject to its privacy practices and not this Privacy Statement.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "4. How We Use Personal Data",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may use Personal Data for the following purposes.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "a. Consent",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may seek, either directly or through our trusted third parties, your separate consent to process your Personal Data, for example, to:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "provide you with information you requested and/or to respond to your inquiries submitted via the website, email and/or phone,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "facilitate certain recruitment activities such as processing employment applications,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "analyze and enhance our communications and strategies (including by identifying when emails sent to you have been received and read),",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "tailor the content we display on our website,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If we have sought your consent to process your Personal Data, you may subsequently withdraw it at any time by contacting us at the address listed in the “",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-8-your-privacy-rights"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "Your Privacy Rights",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "” section below.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "b. Legal obligation",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We may be required by law or regulation to collect and process certain Personal Data about you. For example, we may be required to process certain Personal Data in relation to reporting of adverse events.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "monitor the quality, safety and efficacy of our medicinal products, which includes detecting, assessing and preventing adverse events and reporting to the relevant health authorities to meet legal and regulatory obligations,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Adverse events refer to the unintended or undesirable events after using a medicinal product. They can be minor at times, or they can also involve serious health issues.Moderna processes your Personal Data to comply with legal obligations under applicable pharmacovigilance laws and regulations worldwide and where necessary for our legitimate interests in ensuring appropriate pharmacovigilance standards.Pharmacovigilance laws are issued for reasons of substantial public interest in public health, research as well as quality, safety, and efficacy of medicinal products.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "c. Public interest",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may also process Personal Data to carry out scientific research in the public interest.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "d. Our legitimate interests",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may process your Personal Data where it is necessary for our legitimate interest as a company, including to manage, promote and improve our business and manage our risk. For example, we may process your Personal Data to:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "facilitate our recruitment activities (such as evaluating you as a job candidate for an employment activity, and monitoring our recruitment statistics),",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "tailor the content we display on our website,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "help us comply with our legal or regulatory obligations or our contractual obligations to the U.S. government as a government contractor or other countries as applicable,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "maintain the security, safety or property of the website, and",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "5. How Information is Shared and Disclosed",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may share and disclose information as described at the time information is collected and as described below:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "a. Service providers",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may use third parties to perform services requested or functions initiated by users. In addition, we may disclose Personal Data to identify a user in connection with communications sent through our sites or services. We may also share information, including Personal Data, with our service providers to perform the functions for which we engage them, such as data analysis, system design and maintenance, customer services and for marketing and promotions. When permitted, we also may offer users the opportunity to share information with friends and other users through the Services.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "b. Legal requirements",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "In certain circumstances, Moderna may release your Personal Data in response to a court order, subpoena, search warrant, regulation, binding order of a data protection agency, governmental request or other legal or regulatory process. Moderna may disclose information if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Moderna or others.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "c. Corporate changes",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may transfer information, including your Personal data, in connection with a merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution, bankruptcy or other change of ownership or control by Moderna or any affiliated company (in each case, whether in whole or in part). When one of these events occurs, Moderna will use reasonable efforts to notify users before information is transferred or becomes subject to different privacy practices.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "d. Adverse Event reporting by patients",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may disclose your Personal Data to HCPs, doctors, care givers, in connection with your adverse event report based on your consent or a legal obligation.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "6. How Information is Retained and Secured",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We retain information as long as it is necessary and relevant for our operations and in line with legal obligations. We retain Personal Data to comply with applicable law, prevent fraud, resolve disputes, troubleshoot problems, assist with any investigation, and other actions permitted by law. When your Personal Data is no longer needed for Moderna’s business purposes, we dispose of it subject to applicable law.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "In accordance with applicable laws, we employ reasonable security measures intended to help protect the security of all information submitted through the Services. The security of information transmitted through the internet cannot, however, be guaranteed. We are not responsible for any interception or interruption of any communications or for changes to or losses of data through the internet. Users of our sites and services are responsible for maintaining the security of any password, user ID or other form of authentication involved in obtaining access to password protected or secure areas. Any access to our sites or services through your user ID and password will be treated as authorized by you.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "To help protect your Personal Data, we may suspend your use, without notice, if Moderna suspects or detects any breach of security. Unauthorized access to such areas is prohibited and may lead to criminal prosecution.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "7. Cookies and Similar Technologies",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna’s websites may use cookies and similar technologies. Please click here to read ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/cookie-statement"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "Moderna’s Cookie Statement",
                                                "marks": [
                                                  {
                                                    "type": "italic"
                                                  }
                                                ],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "8. Your Privacy Rights",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna respects your rights related to the processing of your personal data. Depending on the applicable Data Protection Law you may have certain additional rights (see country-specific section below) and you will always have the below rights. You may exercise them by visiting our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "a. Correct/update personal data",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You may correct or update the Personal data you previously provided to Moderna.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "b. Receive marketing communications",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When you register for the services, you may request to receive emails containing information about Moderna you might find useful, including promotions, announcements of new services and products. If you decide, at any time, that you no longer wish to receive these emails you may unsubscribe from our email list by using the relevant “Unsubscribe” link within the respective electronic communications channel, or by contacting us at ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "IMPORTANT NOTE: Moderna cannot comply with a consumer's request to amend or remove information that was provided to Moderna by a healthcare professional or a consumer regarding an adverse drug event due to legal obligations.",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "9. Our Children’s Policy",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Our sites are not intended for use by children. If you are under the age of majority in your place of residence, you may visit our site only with the consent of or under the supervision of your parent or legal guardian.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you believe Moderna may have any information from or about a child, please contact our Privacy Office at ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "10. Changes to This Privacy Statement",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may change or update this Privacy Statement from time to time by publishing a new version on this website. When we do update this Statement, we will revise the “Last Updated” date at the top of this page. Your continued use of the services after the Effective Date constitutes your acceptance of the amended Privacy Statement. The amended Privacy Statement supersedes all previous versions.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "11. Jurisdiction-Specific Privacy Information",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "California",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Privacy Rights",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you are a California resident under age 18 and are a registered user of any of our services, then you may request that we remove any of your User Contributions you publicly posted on or in our services. ",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "To request removal of your User Contribution, please visit our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " (You also may be able to log in to your account and delete your own User Contribution.) Moderna reserves the right to request that you provide information that will enable us to confirm that the User Contribution that you want removed was created and posted by you.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna will make a good faith effort to delete or remove your User Contribution from public view as soon as reasonably practicable. Please note, however, that your request that we delete your User Contribution does not ensure complete or comprehensive removal of your User Contribution. Your User Contribution may remain on backup media, cached or otherwise retained by Moderna for administrative or legal purposes, or your User Contribution may remain publicly available if you or someone else has forwarded or re-posted your User Contribution on another website or service prior to its deletion. Moderna may also be required by law to not remove (or allow removal) of your User Contribution.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "California Civil Code Section 1798.83 permits individual California residents to request certain information regarding Moderna’s disclosure of personal data to third parties for their direct marketing purposes. To make such a request, please write or send an email to the address below.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "California Consumer Privacy Act - Notice for California Residents",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you are a California resident, this Privacy Notice supplements the information above regarding the collection, use, and disclosure of your personal data. ",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "The California Consumer Privacy Act of 2018 (CCPA) gives California consumers the right to know what personal data is collected about them, how it will be used and to whom it is disclosed. California consumers may have the right to request access to and deletion of their personal data, and the right to request that their personal data not be sold to the extent applicable under the CCPA.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "The purpose of this notice is to describe our practices regarding the collection, use, disclosure, and sale of personal data and instructions for submitting CCPA data privacy requests. Some of the Personal Data that we collect, use, and disclose may be exempt from the CCPA because it is regulated by other federal and state laws that apply to us.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We collect personal data from you when you interact with us online (through our Site, our other websites, Apps and Services) or offline (such as through your health care providers, if you are a patient, with your authorization as applicable.) The personal data we may collect from you will depend on the nature of our interaction with you, but can include the following categories that we have collected in the preceding twelve (12) months:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "embedded-asset-block",
                                        "data": {
                                          "target": {
                                            "metadata": {
                                              "tags": [],
                                              "concepts": []
                                            },
                                            "sys": {
                                              "space": {
                                                "sys": {
                                                  "type": "Link",
                                                  "linkType": "Space",
                                                  "id": "n9bebhw263o0"
                                                }
                                              },
                                              "id": "1vo5ULs91JROZ8CfAyGcpI",
                                              "type": "Asset",
                                              "createdAt": "2024-07-10T13:58:26.978Z",
                                              "updatedAt": "2024-07-10T13:58:26.978Z",
                                              "environment": {
                                                "sys": {
                                                  "id": "sandbox",
                                                  "type": "Link",
                                                  "linkType": "Environment"
                                                }
                                              },
                                              "publishedVersion": 5,
                                              "revision": 1,
                                              "locale": "en-US"
                                            },
                                            "fields": {
                                              "title": "Privacy Policy - Personal Data ",
                                              "description": "",
                                              "file": {
                                                "url": privacyPolicyDataTable,
                                                "details": {
                                                  "size": 642894,
                                                  "image": {
                                                    "width": 1174,
                                                    "height": 2046
                                                  }
                                                },
                                                "fileName": "image (4).png",
                                                "contentType": "image/png"
                                              }
                                            }
                                          }
                                        },
                                        "content": []
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Your Rights",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "California residents are provided specific rights subject to certain exceptions.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "The Right to Know. ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "You have the right to request that we disclose what personal data we collect, use, disclose, and sell. The process for exercising this right is describe below under How to Submit a Data Privacy Request.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "The Right to Deletion. ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "You have the right to request deletion of any personal data about you that we have collected from you. The process for exercising this right is describe below under How to Submit a Data Privacy Request",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "The Right to Opt-Out. ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "You have the right to opt-out of the sale of your personal data.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "The Right to Non-Discrimination. ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "You have the right not to be discriminated against for exercising your rights.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "How to Submit a Data Privacy Request",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You may exercise your Right to Know and Right to Deletion by visiting our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " or calling (844) 971-2551.To process your request for access or deletion, we must be able to verify your identity to a reasonable degree of certainty. We will ask you to provide your contact information and additional identifiers based on your relationship with us.You may designate an authorized agent to make a request to access, delete, or opt-out of the sale of your information on your behalf. When you use an authorized agent to submit a request for access or deletion, you must provide the authorized agent with written permission to do so, and, in certain circumstances, we may ask you to verify your own identity directly with us. We may deny a request from an authorized agent that does not submit proof that they have been authorized by you to act on your behalf.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Right to Know:",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  }
                                                ]
                                              },
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Please note that we may not be required to provide you access to the specific pieces of information we have collected about you or delete information if we are unable to verify your identity.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Right to Delete:",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  }
                                                ]
                                              },
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We may not be required to delete information under certain circumstances. Specifically, the CCPA includes exemptions that provide that we do not have to delete data that, for example, is necessary to comply with legal obligations including those pertaining to the quality, safety or effectiveness of a product or activity regulated by the Food and Drug Administration (FDA), complete a transaction, detect security incidents, or for certain other internal purposes.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Sale or Disclosure of Personal data: ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "The CCPA defines “sale” broadly to include sharing, transferring, disclosing or otherwise communicating personal data with a third party for monetary or other valuable consideration. We share personal data with service providers who work on our behalf and agree not to use or sell your personal data for other purposes or if you have intentionally directed us to share information with a third party. In addition, with your approval, we share certain internet tracking data, including cookies and the IP address used to access our websites.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Notice of Financial Incentive:",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  }
                                                ]
                                              },
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Moderna does not offer financial incentives in exchange for the collection or sale of personal data. However, we do provide discounts and incentives to individuals who use our products and services and enroll in incentive programs that we offer from time to time; enrolling in these programs requires you to provide certain of your personal data so that we may administer the programs and, in some cases, provide marketing and advertising to you. Under CCPA, this could be considered an offer of a “financial incentive” and so we provide this notice to you to describe our practice and to provide a good faith estimate of the value of your personal data that we may collect related to the programs.\n\nIn the normal course of our business, we do not assign monetary or other value to personal data, but in accordance with CCPA, we make a good faith estimate that the value of the personal data collected and used is equivalent to the value of the discount or financial incentive we provide in these programs. To make this good faith estimate, we may consider among other factors, the (i) categories of personal data collected, (ii) the discount or incentive offered, (iii) the sales or use of our products and services by those who enroll versus those who do not, and (iv) the cost and expenses we incur in offering the programs.\n\nThe incentive programs require you to opt-in to participate as set forth on the page where you can enroll or opt-in to the programs. You can opt-out either by contacting us at the information set forth below, or by following the terms and conditions provided when you are enrolling in the program. While we will not discriminate against you for exercising your rights under CCPA, if you request deletion of your personal data, we may not be able to delete such information if it is necessary to administer the incentive or discount you requested and still provide you such incentive or discount.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Personal data Collected from Employees, Contractors, Applicants, and Health Care Providers",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Employees ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "– If you are an Moderna employee and would like more information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please contact us at",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              },
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "",
                                                    "marks": [],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "hyperlink",
                                                    "data": {
                                                      "uri": "mailto:privacy@modernatx.com"
                                                    },
                                                    "content": [
                                                      {
                                                        "nodeType": "text",
                                                        "value": "privacy@modernatx.com",
                                                        "marks": [],
                                                        "data": {}
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ".",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Contractors ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "– If you are a contractor performing services for Moderna and would like information about the categories of personal data we collect from you as a contractor and the purpose for which the personal data will be used, please visit our ",
                                                    "marks": [],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "hyperlink",
                                                    "data": {
                                                      "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                    },
                                                    "content": [
                                                      {
                                                        "nodeType": "text",
                                                        "value": "request web page",
                                                        "marks": [],
                                                        "data": {}
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ".",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Job Applicants",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": " – If you are applying for a position with Moderna and would like information about the categories of personal data Moderna collects from you as a job applicant and the purposes for which the personal data, please view our Privacy Statement",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Health Care Providers – ",
                                                    "marks": [
                                                      {
                                                        "type": "italic"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": "If you are a health care provider with whom we have a contractual arrangement and would like information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please visit our ",
                                                    "marks": [],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "hyperlink",
                                                    "data": {
                                                      "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                                    },
                                                    "content": [
                                                      {
                                                        "nodeType": "text",
                                                        "value": "request web page",
                                                        "marks": [],
                                                        "data": {}
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ".",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Children’s Online Privacy Protection Act (COPPA)",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Consistent (COPPA), if we learn that a child under age 13 has provided Personal Data to or through the site without first receiving his or her parent’s verified consent, we will use that information only to respond directly to that child (or his or her parent or legal guardian) to inform the child that he or she cannot use the services and subsequently we will dispose of such Personal Data in accordance with this Privacy Statement.California residents who are unable to review or access this CCPA Notice due to a disability may contact us to request access this CCPA Notice in an alternative format. Please call 1-844- 971-2551 or email us at ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Nevada",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Nevada Residents As Covered by Nevada Privacy Law\nModerna does not sell Covered Information as defined under Nevada law. If you would like to make a further inquiry regarding the selling of your Covered Information, as defined under Nevada law, visit our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "EU/EEA, UK & Switzerland",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna’s processing of your personal data is based on any one of the following legal grounds: (A) legitimate business purposes, (B) where you have provided consent, (C) as necessary to comply with Moderna’s legal and regulatory obligations and (D) as necessary to perform a contract under which you have been engaged.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "embedded-asset-block",
                                        "data": {
                                          "target": {
                                            "metadata": {
                                              "tags": [],
                                              "concepts": []
                                            },
                                            "sys": {
                                              "space": {
                                                "sys": {
                                                  "type": "Link",
                                                  "linkType": "Space",
                                                  "id": "n9bebhw263o0"
                                                }
                                              },
                                              "id": "3dlAOZ38IdeTNBy7LRHGVL",
                                              "type": "Asset",
                                              "createdAt": "2024-07-10T13:57:28.572Z",
                                              "updatedAt": "2024-07-10T13:57:28.572Z",
                                              "environment": {
                                                "sys": {
                                                  "id": "sandbox",
                                                  "type": "Link",
                                                  "linkType": "Environment"
                                                }
                                              },
                                              "publishedVersion": 5,
                                              "revision": 1,
                                              "locale": "en-US"
                                            },
                                            "fields": {
                                              "title": "Privacy Policy EU/EEA, UK & Switzerland ",
                                              "description": "",
                                              "file": {
                                                "url": privacyPolicyDataTable_EU,
                                                "details": {
                                                  "size": 154682,
                                                  "image": {
                                                    "width": 480,
                                                    "height": 379
                                                  }
                                                },
                                                "fileName": "image (3).png",
                                                "contentType": "image/png"
                                              }
                                            }
                                          }
                                        },
                                        "content": []
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "How can you access, correct or delete the personal data about you that we process? You have a right to request to access, correct/update or delete your personal data (including your health information). You may make such a request at any time, by visiting our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ". We will provide you with access to the information we hold about you, correct/update, and or delete that information that was provided to us by a Healthcare Professional or a consumer regarding an adverse drug event.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "It is not technologically possible to remove from our servers each and every record of your information. The need to back-up our systems to protect information from inadvertent loss means that a copy of information about you (including your health-related interests) may exist in a non-erasable form that will be difficult or impossible for us to locate.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Nevertheless, when permitted by law, Moderna will delete your personal data (including health information) stored in the databases Moderna actively uses for research and daily business activities or stored in other readily searchable media. In addition, we will use reasonable efforts not to disclose any personal data stored in a non-erasable format after receiving your request for removal, except as required by law.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "How can you exercise the right to data portability? According to the right to data portability, you have the right to request that your personal data provided to Moderna be delivered to you in a structured, commonly used and machine-readable format, subject to certain conditions and can be requested by visiting our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Make a Privacy Complaint with the ICO (UK). If you feel Moderna’s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Information Commissioner’s Office (ICO) at: ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://ico.org.uk/make-a-complaint/"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "https://ico.org.uk/make-a-complaint/",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Make a Privacy Complaint with the Federal Data Protection Commissioner of Switzerland. If you feel Moderna’s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Federal Data Protection Commissioner at: ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.edoeb.admin.ch/edoeb/en/home.html"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "https://www.edoeb.admin.ch/edoeb/en/home.html",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "How We Manage Disclosure of Transfers of Value",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              },
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna collects data about the transfers of value that you have received from us so that we can comply with our obligations under the IPHA Code, specifically that companies must document and publicly disclose annually certain transfers of value made directly or indirectly to health professionals and other relevant decision makers located in Europe.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna recognizes the legitimate public interest in better understanding the financial relationships that healthcare professionals have with the pharmaceutical industry for the purposes of transparency and trust in the pharmaceutical industry.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "The law requires us to inform you of the legal basis for collecting and processing your personal data where Moderna is the data controller. Where Moderna processes data relating to transfers of value made to you, Moderna relies on the legal basis of legitimate interests to process that data. Moderna’s compliance with the IPHA Code and these further objectives cannot be met without processing personal data about you and the transfers of value that you have received from us. We have carried out a Legitimate Interests Assessment and consider that this processing is necessary, proportionate and without unjustified harm to you.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you do not agree to the disclosure of data relating to transfers of value made to you by Moderna, you can raise an objection via ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Japan",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "In accordance with the Act on Protection of Personal Information of Japan (APPI) and other applicable laws and regulations, Moderna will disclose the personal data that Moderna holds about you according to the applicable procedures. In addition, if you inform Moderna that your personal data is inaccurate, Moderna will review and correct, add or delete the data as required in accordance with applicable laws, regulations and procedures.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Requests may be filed by visiting our ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "request web page",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "; please note that this may require a fee.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "backToTopButtonLabel": "Back To Top",
                                  "printButtonLabel": "Print",
                                  "country": "[Circular Reference]"
                                }
                              },
                              {
                                "metadata": {
                                  "tags": [],
                                  "concepts": []
                                },
                                "sys": {
                                  "space": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "Space",
                                      "id": "n9bebhw263o0"
                                    }
                                  },
                                  "id": "5obyb6hoYaRjLduvLrF9BT",
                                  "type": "Entry",
                                  "createdAt": "2023-05-24T19:10:31.031Z",
                                  "updatedAt": "2023-07-11T18:20:48.597Z",
                                  "environment": {
                                    "sys": {
                                      "id": "sandbox",
                                      "type": "Link",
                                      "linkType": "Environment"
                                    }
                                  },
                                  "publishedVersion": 245,
                                  "revision": 62,
                                  "contentType": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "ContentType",
                                      "id": "richTextContentComponent"
                                    }
                                  },
                                  "locale": "en-US"
                                },
                                "fields": {
                                  "title": "Privacy Policy Rich Text Content Component - DE",
                                  "effectiveDateLabel": "Effective",
                                  "effectiveDate": "2023-01-07",
                                  "disclaimerMessage": "Please read these terms carefully before accessing or using this website",
                                  "content": {
                                    "nodeType": "document",
                                    "data": {},
                                    "content": [
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "This website is owned and operated by Moderna, Inc. (“Moderna”, “we”, “our” or “us”). The materials on our website (the “website” or the “Site”) are provided by Moderna as a service to our customers and the public and may be used for informational purposes only.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna respects the privacy of visitors to our website and recognizes the importance of taking steps to protect the privacy of any information we collect through our website. This Privacy Policy describes the types of Personal Information (as defined below) that we collect about visitors to the Site, how we use the Personal Information, and with whom we may share it. This Privacy Policy also describes (1) the measures we take to protect the personal\ninformation we collect and (2) your rights and privileges regarding our collection, use, and disclosure of your personal information.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Exclusions.",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              },
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " This policy only treats personal information collected through this website. It does not describe how we may collect or use personal information collected oline, and it does not address or govern the privacy practices of other websites (including those we link to) that may have policies of their own. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. Information you provide to us unsolicited may be considered non-confidential, and Moderna may reproduce, use, disclose, and share such unsolicited information with others without permission, compensation, restriction, or aribution.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "By accessing our website, you agree to the terms of this Privacy Policy and the terms of the Agreement. ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "If you do not agree to these terms, you are not authorized to use our website.",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "\n\n",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "\n",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Introduction",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "“",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "Personal Information",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              },
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "” is information that can be used to identify or contact you, such as: Your contact information, including your name, address, email address, country, and phone number, any other information that may appear on your resume if you apply for a job with Moderna through our website, and where required by applicable law, any information about your use of our website or device that may be collected automatically; including the use of\ncookies, web beacons and other tracking technologies.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We will handle your Personal Data in accordance with applicable law and in line with the following principles:\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We will treat your personal data in accordance with applicable law and in accordance with the following principles:",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We process personal data lawfully, fairly and transparently.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We collect personal information only for a specific, explicit and legitimate purpose and use personal information only for the purposes for which it was originally collected.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We limit the collection of personal data to what is necessary for the purpose for which it is processed.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We will use reasonable eorts to ensure that your personal information is accurate and, where appropriate, kept up to date.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We do not store personal data for longer than is necessary for the purpose for which the personal data is processed.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Personal data will only be processed in a manner that ensures appropriate security of the personal data.\n\n",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Our privacy practices are described in more detail below in this Privacy Policy.\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Information We Collect",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You can visit our website without explicitly providing information about yourself. If you choose to submit your information through the “Sign Up for our Mailing List” feature or the “",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://dev.modernadirect.com/en-DE/contact-us"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "Contact Us",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "” feature on our website, or if you apply for a job posting at Moderna through the “",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.modernatx.com/careers/life-at-moderna"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "Careers",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "” section of our website, we may ask you to provide personal information, such as your name, address, telephone number and email address, job title, company name, Your\ncountry, information about your job and other job-related information. You are not required to provide any personal information to Moderna, but your ability to use our website or its features and your ability to apply for a job may be limited if you do not.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Personal data",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " about the use of the website collected through cookies or other automated means. When you use our website, we may automatically collect information about your use of the website, including through the use of cookies, web beacons and other tracking technologies (“Automatically Collected Information”). Automatically collected information may include device information such as IP address, device identifiers and operating systems,\nas well as usage information such as time and duration of use, interaction with content, information stored in cookies or similar technologies. In accordance with EU Regulation 2016/679 on data protection (the “GDPR”), automated information is considered personal data and we treat such automated information as personal data in accordance with this Privacy Policy.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "“Cookies”",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " are small files that the website places on your hard drive for identification purposes. These files are used for registration on the website and to\ncustomize your next visit to our website. For example, cookies store your preferred language and display. Cookies cannot read data from your hard drive.\n\nWe use the following cookies on our website:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Strictly necessary cookies",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ". These are cookies that are necessary for the operation of our website. These include, for example, cookies that enable you to log in to your applicant account. ",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Functionality cookies",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ". s. These are used to recognize you when you return to our website and to embed features of third-party services. This allows us to personalize our content for you, store your preferences (e.g., Your choice of language) and useful third-party services on our website.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "Analytics cookies",
                                                    "marks": [
                                                      {
                                                        "type": "bold"
                                                      }
                                                    ],
                                                    "data": {}
                                                  },
                                                  {
                                                    "nodeType": "text",
                                                    "value": ". We use the Google Analytics platform to collect certain analytical information that helps us to beer understand the activities on our website and to improve our services and the quality of our website. This information includes the IP address, page views, referring websites or advertisements, operating system and browser, and time spent on our website. We receive this data in an aggregated form. We use this information\nto understand how visitors interact with our website, to measure the eectiveness of our advertising on third-party websites, and to improve our visitors’ experience.\n",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You can refuse or accept cookies from this website at any time by activating the cookie seings in your browser. The “Help” menu of most Internet browsers contains information on how to disable cookies, or you can visit ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "https://www.aboutcookies.org/how-to-control-cookies/"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "https://www.aboutcookies.org/how-to-control-cookies",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "/. If you do not accept cookies, some features on our website may not work fully, and you may not be able to access certain information on this website. By continuing to use the website without changing the seings, you agree to the use of cookies.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Personal data from third-party sources. We may, to the extent permied by law, obtain information about you from publicly and commercially available sources, which we may combine with other information we receive from or about you. For example, if you apply for a job at Moderna through our website, we may view your LinkedIn profile.\nAggregated data. We may aggregate and/or de-identify any personal information we collect so that the information no longer identifies a specific individual. We may use, disclose and otherwise process such information without restriction for our own legitimate business purposes – including historical and statistical analysis and business planning.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Aggregated Data",
                                            "marks": [
                                              {
                                                "type": "italic"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ". We may aggregate and/or de-identify any Personal Data that we collect, such that the information no longer identifies any specific individual. We may use, disclose and otherwise process such information for our own legitimate business purposes – including historical and statistical analysis and business planning – without restriction.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "How We Use Personal Data",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may use Personal Data for the following purposes.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-5",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Our legitimate interests",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We may process your personal data where it is necessary for our legitimate interest as a business, including administering, promoting and improving our business and risk management. For example, we may process your personal data in order to:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "provide you with the information you have requested and/or to respond to your requests submied via the Website, email and/or telephone,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "facilitate our recruitment activities (e.g., processing job applications, evaluating you as a candidate for a job and monitoring our recruitment statistics),",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "analyse and improve our communications and strategies (including by determining when e-mails sent to you have been received and read);",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "adapt the content we display on our website,",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "protect against, identify, investigate, and respond to fraud, illegal activities (such as incidents of hacking or misuse of our website), claims, and other recourse;",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "maintain the privacy, security, or property of the Site; and",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "communicate with you for any other purpose arising from the circumstances or of which we inform you when we collect personal information from you.\n",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-5",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Legal Obligation",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We may be required by law to collect and process certain personal data about you. For example, it may be necessary for us to process your personal data in order to comply with our contractual obligations to the U.S. Government as a contractor for the government.\n",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-5",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Your consent",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "unordered-list",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "We may also, either directly or through our trusted third parties, obtain your separate consent to process your personal data, for example, if you choose to receive Moderna news and updates from us, or for the use of non-essential cookies.",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "list-item",
                                            "data": {},
                                            "content": [
                                              {
                                                "nodeType": "paragraph",
                                                "data": {},
                                                "content": [
                                                  {
                                                    "nodeType": "text",
                                                    "value": "If we have obtained your consent to process your personal data, you may subsequently withdraw it at any time by contacting us at the address set out in the “Your Privacy Rights” section below.\n",
                                                    "marks": [],
                                                    "data": {}
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Disclosure of personal data\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We will not sell, share, or otherwise distribute your personal information to third parties except as provided in this Privacy Policy.\n\nAliates and Service Providers. We may share your personal information with other Moderna aliates worldwide who agree to treat it in accordance with this Privacy Policy. We may also share personal data with service providers acting for us or on our behalf for further processing, such as to assess the usefulness of this website, for data management, technical support or to analyse recruitment data. These service providers have contractually agreed to\nuse the personal data only for the purpose(s) for which the data was originally collected or may otherwise be lawfully processed, not to sell your personal data to other third parties and not to disclose it to other third parties, unless required by law, permied by us or specified in this Privacy Policy.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "\nOther parties in connection with a corporate transaction. We may also transfer personal information we have collected from you to a third party as part of\na corporate transaction, such as a merger, acquisition, reorganization, joint venture, financing, or sale of our assets.\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "\nOther parties as required by applicable law or as necessary to protect Moderna. We may share personal information with third parties to comply with\nlegal and regulatory requirements, or to protect against fraud, illegal activity (e.g., in response to incidents of hacking or misuse of our website), and\nclaims and other recourse.\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "International Data Transfers",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "When we share personal information with third parties, such data transfers may involve the transfer of personal information to other countries. These countries may not have the same data protection laws as the country from which the personal data originally originated.\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "EEA area residents only",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "\nModerna in the U.S. acts as a data controller and processes your personal data by determining the purposes and means of processing in accordance with the GDPR. Please note that your personal data will be stored on Aquia’s servers, including inside and outside the European Union. Before we transfer your personal data outside the EEA, we will take steps to ensure that such data receives the same level of protection as under applicable data protection laws within the EEA. For data transfers outside the EEA, we use applicable safeguards where necessary, including standard contractual clauses approved by the European Commission. A copy of these arrangements can be obtained by contacting us at the email address below.\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Your Privacy Rights",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "As a data subject, you may have certain rights under applicable law. For example, you have the right to object to the processing of your personal data or\nto request a restriction of processing and the right to request access to the personal data we hold about you, as well as its correction, deletion and\nportability, subject to certain exceptions required by law. If you would like more information about our use of your personal data, or if you wish to exercise\nyour rights, please contact us at:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "\nModerna, Inc. 200 Technology Square, Cambridge, MA 02139 USA",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:Privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "Privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "EU residents:",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "EUprivacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "EUprivacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": "\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We will endeavor to provide requested information and make requested changes to the extent required and permied by applicable data protection laws and other laws and regulations. In any case, we will do our best to respond to you as soon as possible and inform you of the outcome of your request.\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You can lodge a complaint with the competent supervisory authority if you believe that our processing of your personal data violates applicable law.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Contact information for all EU supervisory authorities can be found here.\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Information",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna employs commercially reasonable administrative, technical, personnel, and physical security measures to protect the personal information in our possession from loss, the, and unauthorized use, disclosure, or alteration. Of course, despite these measures, we cannot guarantee perfect security of the networks, servers and databases operated by us or on our behalf. In particular, e-mails sent to or from the website may not be secure.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Therefore, you should be particularly careful about what information you send to us by e-mail. Please keep this in mind when you provide us with personal\ndata via the website.\n\n\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Data Storage",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Your personal data will only be retained by Moderna for as long as is necessary to fulfil the purpose(s) for which it was collected, depending on the purpose(s) for which the personal data was collected, the nature of the personal data, any contractual relationship governing the retention of the personal data and our legal or regulatory obligations. We will then destroy or anonymize your personal data in accordance with applicable law.\n\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Email Communications",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "In the event that we contact you, including by email, we will provide you with a method by which you can opt in or out of receiving further communications to the extent required by law. For example, you may choose to receive email updates on developments related to Moderna’s products and/or services, or on health-related specific topics (e.g., email updates on Moderna’s methylmalonic acid anemia (MMA)) by filling out the appropriate\nelectronic form “Sign up for our mailing list” on our website. If, at a later date, you decide that you no longer wish to receive such e-mail communications from us, you may unsubscribe from such a contact list by using the appropriate “unsubscribe” link within the relevant electronic communication channel or by sending us an e-mail titled “Unsubscribe from E-mail Updates” to ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " or ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:EUprivacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "EUprivacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Our policy on dealing with children\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We are commied to protecting children’s privacy. The content and services of this website are not intended for or directed at children under the age of 18. Visitors under the age of 18 or children under the age of 18 should not submit any personal information to Moderna through the Site.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "\nIf we become aware that a user of our website is under the age of 18 and has voluntarily provided personal information and/or health-related personal information, or that a healthcare professional has voluntarily provided personal information about a patient identified as under the age of 18 without the given or authorized consent of that child’s legal guardian, we will promptly endeavor to delete such personal information upon notice or request.\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "CalOPPA Do-Not-Track Notice",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "We do not track our website users over time and across third-party websites and therefore do not respond to Do Not Track (DNT) signals. Moderna does not authorize third parties to collect personal information directly from our users on our website, such as through the use of third-party advertising.\n\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Links to Third Party Websites\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "As a convenience to our visitors, this website may contain links to other websites that we believe provide useful information. These links may contain links to websites that may provide services to us. Please note that Moderna is not responsible for the privacy practices of these other websites and cannot guarantee the privacy standards of these other websites. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. This Privacy Policy applies solely to information collected by our website and does not apply to linked websites that do not originate from Moderna.\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Notification of the Privacy Policy\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Updates: If we change our privacy policy, we will post those changes on our website. If we make any changes to this Privacy Policy, we will update the date at the top of this Privacy Policy.\n\n\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "heading-3",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "For Additional Information",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "If you have any questions about this Privacy Policy or concerns about the practices of this website or your dealings with this website, or any privacyrelated maers generally, please email us at ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mailto:privacy@modernatx.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "privacy@modernatx.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": " or contact us in writing at:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna, Inc.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Aention: Legal Department 200 Technology Square,",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Cambridge, MA 02139 USA\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "For EU/EEA residents",
                                            "marks": [
                                              {
                                                "type": "bold"
                                              }
                                            ],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ":\nPlease email us at ",
                                            "marks": [],
                                            "data": {}
                                          },
                                          {
                                            "nodeType": "hyperlink",
                                            "data": {
                                              "uri": "mainto:contact@dpr.eu.com"
                                            },
                                            "content": [
                                              {
                                                "nodeType": "text",
                                                "value": "contact@dpr.eu.com",
                                                "marks": [],
                                                "data": {}
                                              }
                                            ]
                                          },
                                          {
                                            "nodeType": "text",
                                            "value": ".",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "You can also contact us in writing at:",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "DPR Group Oce 29, Clion House Fitzwilliam Street Lower Dublin, Ireland\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "\nFor all other questions or concerns, regardless of where you live, please contact us in writing at:\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Moderna, Inc.",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Aention: Corporate Communications200 Technology Square,",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "Cambridge,",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "MA 02139",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      },
                                      {
                                        "nodeType": "paragraph",
                                        "data": {},
                                        "content": [
                                          {
                                            "nodeType": "text",
                                            "value": "USA\n\n",
                                            "marks": [],
                                            "data": {}
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "backToTopButtonLabel": "Back To Top",
                                  "printButtonLabel": "Print",
                                  "country": {
                                    "sys": {
                                      "type": "Link",
                                      "linkType": "Entry",
                                      "id": "7DX7badGk41XRSy4znPNFI"
                                    }
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    }
                  }
                }
              }
            },
            {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "7oSmj9Iyl3kSocc335XV51",
                "type": "Entry",
                "createdAt": "2022-12-02T04:21:30.182Z",
                "updatedAt": "2022-12-02T04:21:30.182Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 8,
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "contactUsConfirmationComponent"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "title": "Contact Us Confirmation Component",
                "headline": "Request Sent",
                "message": {
                  "data": {},
                  "content": [
                    {
                      "data": {},
                      "content": [
                        {
                          "data": {},
                          "marks": [],
                          "value": "Thank you for reaching out. A representative will reach out shortly.",
                          "nodeType": "text"
                        }
                      ],
                      "nodeType": "paragraph"
                    }
                  ],
                  "nodeType": "document"
                },
                "icon": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "5EWJeaSLcAOTh1XGB5J1Jd",
                    "type": "Asset",
                    "createdAt": "2022-11-08T22:15:01.982Z",
                    "updatedAt": "2022-11-08T22:15:01.982Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 3,
                    "revision": 1,
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "contactusRequestSentLogo",
                    "description": "",
                    "file": {
                      "url": contactusRequestSentLogo,
                      "details": {
                        "size": 35738,
                        "image": {
                          "width": 600,
                          "height": 600
                        }
                      },
                      "fileName": "contactusRequestSentLogo.png",
                      "contentType": "image/png"
                    }
                  }
                },
                "link": {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "7sOHpLfHcBdXJkB7vOBL26",
                    "type": "Entry",
                    "createdAt": "2022-11-09T21:12:00.000Z",
                    "updatedAt": "2022-12-01T20:32:59.726Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 7,
                    "revision": 2,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "internalLink"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Contact Us Internal Link",
                    "label": "Contact Us",
                    "pageReference": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "6aA4Kfs006hNINMMIje8Cq",
                        "type": "Entry",
                        "createdAt": "2022-10-28T20:09:14.397Z",
                        "updatedAt": "2022-12-02T04:38:06.055Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 16,
                        "revision": 3,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "page"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "Contact Us",
                        "title": "Contact Us",
                        "slug": "contact-us",
                        "seo": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3SZXCHhkMg78hB0DVPqLnA",
                            "type": "Entry",
                            "createdAt": "2022-10-28T20:09:14.497Z",
                            "updatedAt": "2022-10-28T20:09:14.497Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 15,
                            "revision": 1,
                            "contentType": {
                              "sys": {
                                "type": "Link",
                                "linkType": "ContentType",
                                "id": "seo"
                              }
                            },
                            "locale": "en-US"
                          },
                          "fields": {
                            "name": "Contact Us - Compose: SEO",
                            "title": "Contact Us Moderna",
                            "description": "Contact Us Moderna",
                            "no_index": false,
                            "no_follow": false
                          }
                        },
                        "content": "[Circular Reference]"
                      }
                    }
                  }
                }
              }
            }
          ]
        },
        "sys": {
          "id": "2XyGZ6yTIb3AUfSz6gUGfw",
          "type": "Entry"
        }
      }
    ]
  }